export default {"src":"/_next/static/media/roadwise-financing-logo-white-en.3cd9db75.svg","height":47,"width":109,"blurWidth":0,"blurHeight":0};